/** Locale helpers for Reversal Catcher UI */

export function getReversalCatcherLocale(language) {
  return language?.startsWith('vi') ? 'vi-VN' : 'en-US';
}

export function formatVndAmount(value, language) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return n.toLocaleString(getReversalCatcherLocale(language), { maximumFractionDigits: 0 });
}

export function parseVndAmount(input) {
  const digits = String(input ?? '').replace(/\D/g, '');
  if (!digits) return 0;
  const n = parseInt(digits, 10);
  return Number.isFinite(n) ? n : 0;
}

export function formatSignalState(t, state) {
  if (!state) return '—';
  const key = `reversalCatcher.states.${state}`;
  const label = t(key);
  return label === key ? state.replace(/_/g, ' ') : label;
}

export function formatExitReason(t, reason) {
  if (!reason) return '—';
  const key = `reversalCatcher.exitReasons.${reason}`;
  const label = t(key);
  return label === key ? reason : label;
}

export function getExitReasonStyle(reason) {
  const styles = {
    TARGET_HIT: { color: '#059669', bg: '#f0fdf4', icon: '🎯' },
    STOP_LOSS: { color: '#dc2626', bg: '#fef2f2', icon: '🛑' },
    TIME_LIMIT: { color: '#d97706', bg: '#fffbeb', icon: '⏰' },
  };
  return styles[reason] || { color: '#64748b', bg: '#f8fafc', icon: '📌' };
}
